export default __webpack_public_path__ + "static/media/Icon-Bilder.d823b11a.svg";